import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=2589e2c8&"
import script from "./user.js?vue&type=script&lang=js&"
export * from "./user.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports